import { Controller } from "@hotwired/stimulus";

interface AgGridOutlet {
  fetchQuestionData(url: string): void;
}

const AG_GRID_ID = "application--toolkit--ag-grid-component--ag-grid-component";

export default class extends Controller {
  static targets = ["questionSelector", "confirmModal"];
  static values = {
    questionDataUrl: String,
    obfuscationUrl: String,
  };

  declare readonly questionSelectorTarget: HTMLSelectElement;
  declare readonly hasQuestionSelectorTarget: boolean;
  declare readonly confirmModalTarget: HTMLElement;
  declare readonly hasConfirmModalTarget: boolean;
  declare readonly questionDataUrlValue: string;
  declare readonly obfuscationUrlValue: string;

  switchQuestion() {
    const grid = this.agGrid();
    if (!grid || !this.hasQuestionSelectorTarget || !this.questionDataUrlValue) return;
    grid.fetchQuestionData(this.buildQuestionDataUrl());
  }

  openConfirmModal() {
    if (!this.hasConfirmModalTarget) return;
    this.confirmModalTarget.removeAttribute("hidden");
    document.body.style.overflow = "hidden";
    const noButton = this.confirmModalTarget.querySelector<HTMLButtonElement>('[data-action*="closeConfirmModal"]');
    if (noButton) setTimeout(() => noButton.focus(), 50);
  }

  closeConfirmModal() {
    if (!this.hasConfirmModalTarget) return;
    this.confirmModalTarget.setAttribute("hidden", "");
    document.body.style.overflow = "";
  }

  backdropClickModal(event: Event) {
    if (event.target === this.confirmModalTarget) this.closeConfirmModal();
  }

  confirmToggleWeighting() {
    this.closeConfirmModal();
    if (!this.obfuscationUrlValue) return;
    const csrfToken = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content ?? "";
    fetch(this.obfuscationUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken,
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "same-origin",
    }).then((response) => {
      if (response.ok) window.location.reload();
    }).catch((error) => {
      console.error("[VoteByVotesController] disable obfuscation error:", error);
    });
  }

  private agGrid(): AgGridOutlet | null {
    const el = this.element.querySelector(`[data-controller~="${AG_GRID_ID}"]`);
    if (!el) return null;
    return this.application.getControllerForElementAndIdentifier(el, AG_GRID_ID) as unknown as AgGridOutlet | null;
  }

  private buildQuestionDataUrl(): string {
    const params = new URLSearchParams();
    if (this.hasQuestionSelectorTarget) {
      params.set("question_id", this.questionSelectorTarget.value);
    }
    return `${this.questionDataUrlValue}?${params.toString()}`;
  }
}
